import DOMPurify from "dompurify";

import { Header, Paragraph } from "components/atoms/Typography";
import { buildHeaderTitleAndUnitsStruct, ProjectReportHeaderAttribute } from "../ProjectsReport.helper";

interface ProjectReportHeaderProps {
    measure: CarbonReductionMeasure;
}

function MeasureReportHeader({ measure }: ProjectReportHeaderProps) {
    const displayData = {
        carbonReductionMeasureCategory: measure.carbonReductionMeasureCategory || "",
        carbonReductionMeasureLife: measure.measureLife || 0,
        carbonReductionMeasureSize: measure.measureSize || 0,
        carbonReductionMeasureType: measure.carbonReductionMeasureType || "",
        carbonReductionMeasureUnitCost: measure.measureUnitCost,
        carbonReductionMeasureSizeUnit: measure.sizeUnit,
        yearApplied: measure.yearApplied || 0,
    };

    const sanitizedDescription = DOMPurify.sanitize(measure.description, {
        ADD_ATTR: ["target", "rel"],
    });

    return (
        <div className="project-report-header">
            <div>
                <Header size="medium" style={{ marginBottom: "1rem" }}>
                    {measure.carbonReductionMeasureType}
                </Header>

                <div className="project-report-header__row">
                    {buildHeaderTitleAndUnitsStruct(displayData).map(({ title, titleValue, icon, unit }) => (
                        <ProjectReportHeaderAttribute
                            key={measure.carbonReductionMeasureType}
                            title={title}
                            titleValue={titleValue}
                            unit={unit}
                            icon={icon}
                        />
                    ))}
                </div>
            </div>
            {measure.description && <Paragraph dangerouslySetInnerHTML={{ __html: sanitizedDescription }} />}
        </div>
    );
}

export default MeasureReportHeader;
